<script>
    import {
        getResultsQuery,
        getWidthsQuery,
        getHeightsQuery,
        getDiametersQuery,
        getBearingsQuery,
        getInsulationClassesQuery,
        getTemperaturesQuery
    } from "../utils/sqlQueries.ts";

    async function makeConnection() {
        const sqlPromise = await initSqlJs({
            locateFile: filename => `/dist/${filename}`
        });
        const dataPromise = await fetch('/dist/db.hvac').then((res) => res.arrayBuffer());
        const [SQL, buf] = await Promise.all([sqlPromise, dataPromise]);
        return new SQL.Database(new Uint8Array(buf));
    }

    export async function getSelections(type) {
        const db = await makeConnection();

        const diameterResult = db.prepare(getDiametersQuery(type));
        const bearingResult = db.prepare(getBearingsQuery(type));
        const widthsResult = db.prepare(getWidthsQuery());
        const heightsResult = db.prepare(getHeightsQuery());

        let diameters = [];
        let bearings = [];
        let widths = [];
        let heights = [];

        while (diameterResult.step()) {
            diameters.push(diameterResult.getAsObject());
        }

        while (bearingResult.step()) {
            bearings.push(bearingResult.getAsObject());
        }

        while (widthsResult.step()) {
            widths.push(widthsResult.getAsObject());
        }

        while (heightsResult.step()) {
            heights.push(heightsResult.getAsObject());
        }

        return {
            diameters: diameters,
            bearings: bearings,
            widths: widths,
            heights: heights,
            insulationClasses: [],
            temps: []
        };
    }

    export async function getInsulationClasses(type, placement, diameter, bearing) {
        const db = await makeConnection();
        let insulationClasses = [];
        const insulationResults = db.prepare(getInsulationClassesQuery(type, placement, diameter, bearing));

        while (insulationResults.step()) {
            insulationClasses.push(insulationResults.getAsObject());
        }

        return insulationClasses;
    }

    export async function getTemperatures(type, placement, diameter, bearing, insulationClass) {

        const db = await makeConnection();
        let temperatures = [];
        const temperatureResults = db.prepare(getTemperaturesQuery(type, placement, diameter, bearing, insulationClass));

        while (temperatureResults.step()) {
            temperatures.push(temperatureResults.getAsObject());
        }

        return temperatures;
    }

    export async function getResults(input) {
        const db = await makeConnection();

        const query = getResultsQuery(input.type.label, input.placement.label, input.diameter.diameter,
            input.bearing.bearing, input.insulationClass.insulation_class, input.temp.temp);

        const results = db.prepare(query);
        let resultList = [];

        while (results.step()) {
            resultList.push(results.getAsObject())
        }

        resultList.sort((a, b) => (a.name > b.name) ? 1 : -1)

        return resultList;
    }
</script>